import React, { useState, useEffect, useRef, useCallback } from 'react'

import {
    Box,
    Container,
    styled,
    Card
} from '@mui/material';

import { useNavigate, Link } from 'react-router-dom';

import DataGridRowActionMenu from '../../common/DataGridRowActionMenu';
import { icons } from '../../common/CommonIcons';
import CommonBreadcumbs from '../../common/CommonBreadcumbs';
import CommonRestricted from '../../common/CommonRestricted';
import DataGridTable from '../../common/DataGridTable';
import DataGridToolbar from '../../common/DataGridToolbar';

import { useDataGridParams } from '../../../hooks/useDataGridParams';
import { useAppContextFeatures } from '../../../context/AppContext';
import { useDocuments, documentTypes, targetTypes } from '../../../hooks/api/useDocuments';
import { useSystemPrompt } from '../../../hooks/useSystemPrompt'
import { useSystemRoutes, routeTypes } from '../../../hooks/useSystemRoutes';
import { useSystemHead, headTitles } from '../../../hooks/useSystemHead';
import { usePermissions, scopeIds, scopeTypes, functionTypes } from '../../../hooks/usePermissions';
import { useTranslations } from '../../../hooks/useTranslations';

const StyledCard = styled(Card)(({ theme }) => ({
    // padding: theme.spacing(4)
}));

export default function ListItemTransform({
    routeType
}) {
    const { t } = useTranslations({ ns: ["common", "@document"] })

    const navigate = useNavigate();

    const { promptMessage } = useSystemPrompt();
    const { list, remove } = useDocuments({ documentType: documentTypes.itemTransform, targetType: targetTypes.itemTransform});
    const { defineColumns, defineRowMenuRender, columns, filterValues, getRenderColumnLink, getRenderColumnDateDisplay, getRenderColumnTextDisplay } = useDataGridParams('id')

    // const [ gridRef, setGridRef ] = useState(null)
    const [selectedIds, setSelectedIds] = useState([])
    const [refreshDataGrid, setRefreshDataGrid] = useState(0)
    const { getLocationIds } = useAppContextFeatures();
    const { getRoute } = useSystemRoutes(routeType)
    const { getHtmlHead } = useSystemHead(routeType)
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.document.id, scopeTypes.document.itemRelocate.id)

    const gridRef = useRef();

    useEffect(() => {

        setRefreshDataGrid(val => val + 1)

    }, [getLocationIds])


    useEffect(() => {

        defineColumnsView()

    }, [])

    const defineColumnsView = () => {

        defineColumns([
            {
                name: "location_name",
                header: t("location"),
            },
            {
                name: "doc_number",
                header: t("docNo"),
                renderValue: ({ cellProps, value }) => {

                    if (isPermissionAllow({ functionType: functionTypes.pageView.id }) === false) {
                        return getRenderColumnTextDisplay(value)
                    }

                    let path = getRoute(`documents/itemTransform/view/${cellProps.data.id}`);

                    return getRenderColumnLink(path, value)
                }
            },
            {
                name: "doc_date",
                header: t("docDate"),
                renderValue: ({ cellProps, value }) => getRenderColumnDateDisplay(value)
            },
            {
                name: "profile_name",
                header: t("profile"),
            }
        ])

    }

    const resetDataGridTableSelection = () => {
        setSelectedIds([])
    }

    const fetchData = async (props) => {

        resetDataGridTableSelection();

        try {

            // const result = await list({ ...props, customFilterLocationEnable: true, customFilterLocationField: 'location_id' })
            props.customFilterLocationEnable = true;
            props.customFilterLocationFields = ['location_id']

            const result = await list(props)

            return {
                data: result?.data?.documents,
                count: result?.data?.nofilter_total
            }

        } catch (error) {

            promptMessage(false, `Error getting results (${error?.message})`)

            return {
                data: [],
                count: 0
            }
        }

    }

    // const handleDelete = async () => {

    //     try {
    //         const result = await remove({ ids: selectedIds })

    //         promptMessage(true, result?.message)
    //         setRefreshDataGrid(val => val + 1)

    //         resetDataGridTableSelection();

    //     } catch (error) {
    //         promptMessage(false, error?.message)
    //     }

    // }

    const RenderToolbar = () => {

        const getToolbarMainMenus = () => {

            let props = [];

            if (isPermissionAllow({ functionType: functionTypes.pageNew.id })) {
                props.push({
                    displayIconName: icons.plus,
                    onClick: () => {

                        navigate(getRoute("documents/itemTransform/new"));

                    }
                })
            }

            return props
        }

        // const getActionOnClick = () => {

        //     let handleFunction = null

        //     if (isPermissionAllow({ functionType: functionTypes.remove.id })) {
        //         handleFunction = handleDelete
        //     }

        //     return handleFunction
        // }

        return (
            <DataGridToolbar
                selectedRowCount={
                    selectedIds.length
                }
                mainMenus={
                    getToolbarMainMenus()
                }
                // actionOnClickRemove={
                //     getActionOnClick()
                // }
                actionMenus={[]}
            />
        )
    }

    const RenderDataGridTable = () => {

        return (
            <DataGridTable
                ref={gridRef}
                refresh={refreshDataGrid}
                fetchData={fetchData}
                dataGrid={{
                    idProperty: "id",
                    style: {
                        // minHeight: 600
                    },
                    // pageSizes: [20, 50, 100],
                    // defaultLimit: 10,
                    // defaultSkip: 0,
                    // checkboxColumn:
                    //     isPermissionAllow({ functionType: functionTypes.remove.id }),
                    checkboxColumn: false,
                    columns,
                    defaultFilterValue: filterValues,
                    onSelectionChange: (items) => {
                        setSelectedIds(
                            items
                        )
                    }
                }}

            />
        )

    }


    return (
        <Box>
            {
                getHtmlHead({ routeType, title: headTitles.itemTransforms })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={t("itemTransforms")}
                breadcrumbs={[
                    {
                        displayText: t("itemTransforms"),
                        props: {
                            // underline: "hover",
                            // href: "/"
                        }
                    }
                ]}
            />

            {
                isPermissionAllow({ functionType: functionTypes.pageList.id }) ?
                    <>
                        {
                            RenderToolbar()
                        }
                        {
                            RenderDataGridTable()
                        }
                    </>
                    :
                    (
                        <CommonRestricted />
                    )
            }

        </Box>
    )
}
